import cn from "classnames"
import React, { useEffect, useMemo } from "react"
import { getDistinct, sortAscending, useSelector } from "swiipe.portal.shared"
import { translationSelectors } from "../../../store/reducers/translationSlice"
import "./TranslationTagFilterInput.scss"

interface ITranslationTagFilterInputProps {
    className?: string
    tagNames: string[]
    onAdd: (tagName: string) => void
    onRemove: (tagName: string) => void
}

const TranslationTagFilterInput = ({ tagNames, onAdd, onRemove, className }: ITranslationTagFilterInputProps) => {
    const tags = useSelector(translationSelectors.tags)
    const allTagNames = useMemo(
        () =>
            sortAscending(
                getDistinct(tags, (t) => t.name).map((t) => t.name),
                (name) => name
            ),
        [tags]
    )

    useEffect(() => {
        const completelyRemoved = tagNames.filter((tn) => !allTagNames.includes(tn))
        completelyRemoved.forEach((tn) => onRemove(tn))
    }, [allTagNames])

    return (
        <div className={cn("translation-tag-filter-input", className)}>
            {allTagNames.length === 0 && <span>No tags yet.</span>}
            {allTagNames.map((tagName) => {
                const isSelected = tagNames.includes(tagName)
                return (
                    <div
                        className={cn(
                            "translation-tag-filter-input__tag",
                            isSelected && "translation-tag-filter-input__tag--selected"
                        )}
                        key={tagName}
                        onClick={() => {
                            if (isSelected) {
                                onRemove(tagName)
                            } else {
                                onAdd(tagName)
                            }
                        }}
                    >
                        {tagName}
                    </div>
                )
            })}
        </div>
    )
}

export default React.memo(TranslationTagFilterInput)
